// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/inventory/cracking-run/${file}.vue`);

export default [
  {
    path: "/grower-ready",
    name: "cracking-run-grower-ready",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CrackingRunGrowerReady",
    },
    components: {
      content: lazyLoad("grower-ready"),
    },
  },
];
